<template>
    <div>
        <Scene10/>
        <Scene11/>
        <Scene12/>
    </div>
</template>

<script>
import { Sprite, Container } from 'pixi.js'
import ChapterMixin from '@/mixins/Chapter'
import Scene10 from './scenes/Scene10'
import Scene11 from './scenes/Scene11'
import Scene12 from './scenes/Scene12'

export default {
    name: 'LibraryOfParliament',
    mixins: [ ChapterMixin ],
    components: { Scene10, Scene11, Scene12 },
}
</script>
